import SidebarNav from './sidebar-nav';

const sidebarNavConfig = {
  name: 'sidebar-nav',
  class: SidebarNav,
  querySelector: {
    navButton: '.sidebar-nav-toggle button',
    navContent: '.sidebar-nav',
  },
  querySelectorAll: {
    navItems: '.wp-block-navigation-link .wp-block-navigation-item__content',
    navSubMenus: '.wp-block-navigation-submenu.has-child',
  },
};

export default sidebarNavConfig;
